var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCollected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.858,
    y1: 0.111,
    x2: 0.162,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003883"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 17.84,
    height: 16.84,
    fill: "#003883"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883",
    transform: "translate(-103 -153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16854",
    "data-name": "Rectangle 16854",
    width: 36,
    height: 36,
    rx: 8,
    transform: "translate(103 153)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10221",
    "data-name": "Group 10221",
    transform: "translate(112 163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.012,13.134A3.439,3.439,0,0,1,1.1,10.5Q5.138,6.461,9.179,2.425a.316.316,0,0,0,.076-.368A1.591,1.591,0,0,1,10.877,0a1.527,1.527,0,0,1,1.015.448c1.487,1.488,2.983,2.965,4.456,4.467A1.57,1.57,0,0,1,15.6,7.553a3.943,3.943,0,0,1-.874-.016.515.515,0,0,0-.33.085c-2.712,2.7-5.41,5.41-8.125,8.1a3.506,3.506,0,0,1-3.779.9,3.552,3.552,0,0,1-2.475-2.94,3.167,3.167,0,0,1,0-.555m11.9-4.552L11.868,8.5c-.062,0-.123-.01-.185-.01-2.269,0-4.538,0-6.808.008a.651.651,0,0,0-.4.189c-.853.835-1.695,1.681-2.537,2.527a2.555,2.555,0,0,0-.821,2.356A2.457,2.457,0,0,0,2.889,15.61a2.411,2.411,0,0,0,2.539-.6c1.65-1.623,3.278-3.269,4.918-4.9.517-.515,1.046-1.019,1.569-1.529m1.747-1.8-3.6-3.62L5.84,7.383h.338c2.029,0,4.059-.022,6.088.014a1.452,1.452,0,0,0,1.361-.575c.011-.015.023-.029.033-.043M10.213,1.591A4.928,4.928,0,0,0,10.6,2.1c.793.8,1.594,1.6,2.393,2.4q.914.913,1.83,1.824a.468.468,0,0,0,.521.163.5.5,0,0,0,.142-.889q-1.355-1.357-2.709-2.713c-.537-.537-1.079-1.069-1.613-1.608a.469.469,0,0,0-.58-.117c-.141.078-.226.255-.367.426",
    transform: "translate(0 0)",
    fill: "#003883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M266.184,160.289a1.611,1.611,0,0,1-.994,1.489,1.574,1.574,0,0,1-1.743-.333,1.52,1.52,0,0,1-.332-1.76c.3-.6.648-1.183,1-1.754a.517.517,0,0,1,.885-.022c.365.577.7,1.171,1.027,1.772a2.486,2.486,0,0,1,.151.608m-1.608-.978c-.175.308-.331.547-.45.8a.453.453,0,0,0,.13.574.434.434,0,0,0,.584.025.621.621,0,0,0,.21-.485,5.649,5.649,0,0,0-.475-.917",
    transform: "translate(-248.344 -148.904)",
    fill: "#003883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M74.841,184.427c-.66.532-.872.589-1.134.313s-.19-.489.383-1.186a2.269,2.269,0,0,1-.351-.251.553.553,0,0,1-.015-.814.535.535,0,0,1,.79.043c.1.095.183.208.29.333.151-.144.264-.261.387-.368a.534.534,0,0,1,.772.006.567.567,0,0,1-.023.8c-.1.1-.219.2-.271.242a7.989,7.989,0,0,1,.434.844.417.417,0,0,1-.135.342c-.511.458-.8-.029-1.126-.3",
    transform: "translate(-69.463 -172.196)",
    fill: "#003883"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCollected);
export default __webpack_public_path__ + "static/media/totalCollected.9309bb0ad7a206fc3170ba330896dce5.svg";
export { ForwardRef as ReactComponent };